import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import TextValue from "./controls/TextValue";
import Col from "./layout/Col";
import Grid from "./layout/Grid";
import Row from "./layout/Row";

export function JornadaLaboralList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((jornada, index) => (
        <ListGroupObjectItem
          value={jornada}
          editable
          onEdit={(event) => {
            event.preventDefault();
            select(index);
            document.getElementById("regimenLaboral").scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}
          deletable
          onDelete={(event) => {
            event.preventDefault();
            remove(index);
          }}
          disabled={disabled}
        >
          {({ value }) => (
            <Grid>
              <Row>
                <Col>
                  <TextValue
                    label={t("jornadaLaboral.diaSemana")}
                    value={value?.diaSemana}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextValue
                    label={t("jornadaLaboral.inicio")}
                    value={value?.inicio}
                  />
                </Col>
                <Col>
                  <TextValue
                    label={t("jornadaLaboral.termino")}
                    value={value?.termino}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextValue
                    label={t("jornadaLaboral.turnos")}
                    value={value?.turnos}
                  />
                </Col>
              </Row>
            </Grid>
          )}
        </ListGroupObjectItem>
      ))}
    </ListGroup>
  );
}
